import { HttpErrorResponse } from '@angular/common/http';
import { ApiException, ApiExceptionConstructor } from 'src/core/common/domain/exceptions/api-exception';

export class NoConnectionException extends ApiException implements ApiExceptionConstructor {
  constructor(message?: string, error?: HttpErrorResponse | Error) {
    super(message, error);
    this.name = 'NoConnectionException';
  }

  static fromError(error: HttpErrorResponse | Error): NoConnectionException {
    return new this(error.message, error);
  }
}
